
import { Download } from "@mui/icons-material";
import { useGeneralAppStore } from "../../store/generalAppStore";
import { useRifaStore } from "../../store/rifaStore";
import Modal from "../Modal";
import ModalCustom from "../ModalCustom";
import useWindowSize from "../../hooks/sizeWindow";
import { Alert } from "react-bootstrap";

const ModalInfoDomicilio = () => {

    const { modals, handlerModal } = useGeneralAppStore()
    const { solicitud } = useRifaStore();
    const size = useWindowSize();

    return (
        <>
            <ModalCustom
                show={modals.includes('info-domicilio')}
                size={"md"}
                onHide={() => handlerModal({ modal: false, modalName: "info-domicilio" })}
                title={() => "Información completa del domicilio"}
                bg={"#E2CFF4"}
                bgHeader={"#1976D2"}
                colorHeader={"#fff"}
            >
                <>
                    <section  style={{color:"#742ABE"}}>

                        <p className="mb-3">La carga del domicilio debe estar completa con la siguiente información:</p>

                        <ul>
                            <li>Dirección</li>
                            <li>Altura</li>
                            <li>Departamento</li>
                            <li>Manzana</li>
                            <li>Lote</li>
                            <li>Provincia</li>
                            <li>País</li>
                        </ul>

                    </section>
                    {/* Info de domicilio */}

                </>
            </ModalCustom>
        </>
    );
}
export default ModalInfoDomicilio;